import { Folder, FolderPlus } from 'lucide-react';

export default function MoveFlowModal({ flow, folders, onClose, onMove }) {
  return (
    <div className="manage-bots-modal-overlay" onClick={onClose}>
      <div className="manage-bots-modal" style={{ maxWidth: 380 }} onClick={e => e.stopPropagation()}>
        <div className="manage-bots-modal-header">
          <h3><Folder size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} /> Mover Fluxo</h3>
          <button className="manage-bots-close" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>
        <p className="text-sm text-white/40 mb-4">
          Escolha a pasta do fluxo <strong className="text-white">"{flow.name}"</strong>.
        </p>
        <div className="flex flex-col gap-2">
          <button
            className={`flex items-center gap-2 text-sm text-white rounded-xl px-3 py-2.5 border transition-colors text-left ${!flow.folder_id ? 'border-white/40 bg-white/[0.08]' : 'border-white/[0.06] bg-white/[0.03] hover:bg-white/[0.06]'}`}
            onClick={() => onMove(flow, null)}
          >
            Sem pasta
          </button>
          {folders.map(folder => (
            <button
              key={folder.id}
              className={`flex items-center gap-2 text-sm text-white rounded-xl px-3 py-2.5 border transition-colors text-left ${flow.folder_id === folder.id ? 'border-white/40 bg-white/[0.08]' : 'border-white/[0.06] bg-white/[0.03] hover:bg-white/[0.06]'}`}
              onClick={() => onMove(flow, folder.id)}
              style={{ color: folder.color }}
            >
              {folder.name}
            </button>
          ))}
        </div>
        {folders.length === 0 && (
          <p className="text-xs text-white/30 mt-2">
            Você ainda não tem pastas — crie uma pelo botão <FolderPlus size={11} style={{ display: 'inline' }} /> na lista.
          </p>
        )}
        <div className="manage-bots-footer" style={{ marginTop: '1rem' }}>
          <div />
          <div className="manage-bots-footer-actions">
            <button className="btn-secondary" onClick={onClose}>Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
